import React, { useState, useEffect, useRef } from 'react';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import SearchIcon from '../../images/icons/searchIcon.svg';
import './Responsive.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AutoCompleteFilterBar from '../../common/components/AutoCompleteFilterBar/AutoCompleteFilterBar';
import FilterOptionsInPrinciple from '../../components/FilterInPrinciple/FilterInPrinciple';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import SelectedFilters from '../../components/Table/SelectedFilters';

const SearchBarFocused = (searchContainer, serchBarPlaceHolder) => {
  let searchinput =
    searchContainer.current.children[0].children[0].children[1].children[0];
  searchinput.placeholder = serchBarPlaceHolder;
  searchinput.style.height = '32px';
};

const TableTopHeader = ({
  filterText,
  onFilter,
  onSearch,
  total_data,
  serchBarPlaceHolder,
  GetLeadStatus,
  filterCaption,
  filterImage,
  tableListbelongs,
  filterComponent,
  labelText,
  rm,
  rmId,
  setRmId,
  customHeaderComponent,
  onSerachChange,
  filterStyle,
  searchStyle,
  showNumberOfListStyle,
  leftSideHeaderComoponent,
  filterContanier,
  filterBlock,
  multiSelect = true,
  ...props
}) => {
  const [searchbar, setSearchBar] = useState('');
  const [filter, setFilter] = useState({ value: '', label: labelText });
  const [statusFilterList, setStatusFilterList] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [initialValue, setInitialValues] = useState(true);
  const [filterInfo, setFilterInfo] = useState(getFiltersInfo());
  const [filterList, setFilterList] = useState({});
  const [filteredData, setFilterData] = useState({});
  const [triggerNewFilterData, setTriggerNewFilterData] = useState(false);

  const searchContainer = useRef(null);

  useEffect(() => {
    if (filterText) setFilter({ value: filterText, label: filterText });
  }, [filterText]);
  const UpdateFilter = () => {
    setLoading(false);
    filterComponent && typeof GetLeadStatus === 'function'
      ? GetLeadStatus()
          .then(res => {
            if (res) {
              let filterOptions = [],
                initialValues = [];
              res.map(e => {
                filterOptions.push({
                  title: e,
                  checked: getChekedList().includes(e) ? true : false
                });
                initialValues.push({ e: false });
              });
              setFilterList(filterOptions);
              setInitialValues(initialValues);
            }
          })
          .catch(err => {})
      : filterComponent && GetLeadStatus instanceof Array
      ? setFilterList(GetLeadStatus)
      : null;
  };

  const getChekedList = () => {
    if (typeof filterInfo?.status == 'string') {
      return filterInfo?.status?.split(',');
    } else return [];
  };

  const handlerFilter = (filters, productType) => {
    let data = getFiltersInfo();
    if (data) {
      if (productType) {
        data['productType'] = Object.keys(productType).filter(
          k => productType[k]
        )[0];
      }
      data['status'] = filters;
      setFiltersInfo(data);
    } else {
      setFiltersInfo({
        ...(productType
          ? {
              productType: Object.keys(productType).filter(
                k => productType[k]
              )[0]
            }
          : {}),
        status: filter
      });
    }
  };

  const handleResetFilters = () => {
    onFilter('');
    let data = getFiltersInfo();
    if (data) {
      data['productType'] = '';
      setFiltersInfo(data);
    } else {
      setFiltersInfo();
    }
    let allFilters = statusFilterList;
    allFilters.map(each => (each.checked = false));
    setStatusFilterList(allFilters);
    typeof props?.filteredObject == 'function' && props?.filteredObject(data);
  };

  useEffect(() => {
    setFilterList(GetLeadStatus);
  }, [GetLeadStatus]);

  const applyHandler = (name, filterName) => {
    setTriggerNewFilterData({ name: name, filterName: filterName });
  };

  return (
    <>
      <SelectedFilters
        filteredData={filteredData}
        onCloseHandler={applyHandler}
      />

      {typeof customHeaderComponent == 'function' ? (
        customHeaderComponent()
      ) : (
        <div
          className={
            (rm
              ? 'flex  flex-row flex-wrap  justify-between '
              : 'lg:flex  left-0  items-center block mx-auto  ') +
            ' w-full  h-full   lg:py-0 items-center '
          }
          onLoad={() =>
            Loading
              ? (SearchBarFocused(searchContainer, serchBarPlaceHolder),
                UpdateFilter())
              : null
          }
        >
          {typeof leftSideHeaderComoponent == 'function'
            ? leftSideHeaderComoponent()
            : null}

          <div
            className={
              (rm ? 'md:w-auto' : 'mx-auto ') +
              ` w-full  flex  items-center my-3 ${filterContanier}`
            }
          >
            {filterComponent ? (
              <div className="w-6/12 lg:w-48 flex " style={filterStyle}>
                {filterImage ? (
                  <div
                    className="z-10 w-4"
                    style={{
                      width: '20px',
                      marginRight: '-24px',
                      marginTop: '7px',
                      marginLeft: '12px'
                    }}
                  >
                    <FontAwesomeIcon
                      icon={filterImage}
                      alt="filterImage"
                      style={{
                        minWidth: '100%',
                        paddingRight: '2px',
                        color: 'gray'
                      }}
                    />
                  </div>
                ) : null}

                <FilterOptionsInPrinciple
                  setFilteredData={''}
                  addFilter={data => {
                    let new_filter = '';
                    let sd = filterBlock ? data[filterBlock] : data.Status;
                    if (filterBlock) {
                      onFilter(data);
                    } else {
                      Object.keys(sd).map((each, index) => {
                        if (sd[each] && typeof sd[each] == 'boolean')
                          new_filter += each + ',';
                      });
                      new_filter = new_filter.slice(0, -1);
                      onFilter(new_filter, data?.Product);
                      handlerFilter(new_filter, data?.Product);
                      typeof props?.filteredObject == 'function' &&
                        props?.filteredObject(data);
                    }
                  }}
                  filterOptions={filterList}
                  multiSelect={multiSelect}
                  initialValues={{
                    Product: true,
                    Status: initialValue
                  }}
                  resetFilter={handleResetFilters}
                  filerCaption={
                    <span className="capitalize ">{filterCaption}</span>
                  }
                  filterListsStyle={{
                    maxHeight: '140px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    display: 'flex'
                  }}
                  triggerNewFilterData={triggerNewFilterData}
                  setFilterData={setFilterData}
                />
              </div>
            ) : null}
            <p
              className="font-roboto font-normal text-xs text-black-500 ml-3 lg:-ml-4"
              style={showNumberOfListStyle}
            >
              List of {total_data} {tableListbelongs}
            </p>
          </div>
          {rm ? (
            <div className="mx-2 my-2">
              <AutoCompleteFilterBar setRmId={setRmId} rm={rmId} />
            </div>
          ) : null}
          <div
            className={
              (!rm
                ? 'lg:absolute my-4 lg:my-0  mr-3 mx-5 mx-auto ml-auto mt-6 lg:w-5/12 '
                : '   lg:w-4/12') + ' right-0 w-full   flex   '
            }
            ref={searchContainer}
            style={searchStyle}
          >
            <CommonInput
              name="searchbar"
              id="searchbar"
              onChange={event => {
                !onSerachChange
                  ? (setSearchBar(event.target.value),
                    onSearch(event.target.value))
                  : (onSerachChange(event.target.value),
                    setSearchBar(event.target.value));
              }}
              value={searchbar}
              stylesContainer={{
                height: '40px',
                maxWidth: '100%',
                marginBottom: '0px',
                fontSize: '40px',
                color: 'rgba(0,0,0,0.87)',
                outline: 'none'
              }}
              dropdownStyle={{
                top: '40px',
                color: 'rgba(0,0,0,0.87)',
                fontSize: '16px',
                backgroundColor: '#fff',
                alignItems: 'center',
                fontFamily: 'Roboto',
                fontWeight: 400
              }}
              styleText={{
                fontSize: '16px',
                padding: '0 25px'
              }}
            />
            <img
              className="w-8 -ml-10"
              src={SearchIcon}
              style={{ zIndex: '1' }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TableTopHeader;
